import { FC } from 'react';
import i18next from 'i18next';
import styled from 'styled-components';

const MessageWrapper = styled.div`
  padding: 60px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.red.a10};
  font-size: 1rem;
`;

const ErrorLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  margin-left: 5px;
`;

interface Props {
  t: i18next.TFunction;
}

const TableError: FC<Props> = ({ t }) => {
  const reload = () => window.location.reload();

  return (
    <MessageWrapper>
      <span data-translation={'x.compare.table.error'}>{t('x.compare.table.error')}</span>
      <ErrorLink data-translation={'x.compare.table.error.link'} onClick={reload}>
        {t('x.compare.table.error.link')}
      </ErrorLink>
    </MessageWrapper>
  );
};

export default TableError;
